import dataFormat from '@home/utils/dbDataFormat/dataFormat';

export const getFormatNotes = (list: any[], selectedMonthStr: string) => {
  const parseNoteUrl = (raw: any) => {
    let parsed = raw;
    if (typeof raw === 'string' && raw.trim()) {
      try {
        parsed = JSON.parse(raw);
      } catch {
        parsed = [];
      }
    }
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.map((item: any) => ({
      name: item?.name || item?.file || '',
      path: item?.path || item?.url || '',
    }));
  };

  return (list || []).map((item: any) => ({
    project_id: item?.project_id,
    game_title: item?.game_title,
    date: selectedMonthStr,
    avatar: item?.cover,
    note: item?.note?.note || '',
    attach: parseNoteUrl(item?.note?.url),
  }));
};


export const formatMainValue = (
  num?: number | null,
  formatter?: string,
  unit?: string,
): string => {
  if (num === null || num === undefined || isNaN(num)) {
    return '-';
  }

  let formattedValue: string;
  if (formatter) {
    try {
      const formatRule = (
        formatter === 'thousands2Decimal' || formatter === '0,0.00'
      )
        ? 'db_bm00'
        : formatter;
      const formatted = dataFormat({ value: num, formatRule });
      formattedValue = (
        formatted === null ||
        formatted === undefined ||
        formatted === 'NaN' ||
        (typeof formatted === 'number' && isNaN(formatted))
      )
        ? num.toLocaleString()
        : String(formatted);
    } catch (error) {
      formattedValue = num.toLocaleString();
    }
  } else {
    formattedValue = num.toLocaleString();
  }

  if (unit === 'hour') {
    return `${formattedValue}H`;
  }
  if (unit === 'USD' || unit === 'RMB') {
    return `$${formattedValue}`;
  }
  return formattedValue;
};
